import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackGeneratedShareUrl.meta';

export type ShareUrlGeneratedObjectType = 'clip' | 'board' | 'collection' | 'canvas' | 'asset';

export type ShareUrlGeneratedVersion = 'current' | `v${number}`;

export type ShareUrlGeneratedComments = 'hide' | 'read_only' | 'allow';

export type ShareUrlGeneratedCustomFields = 'hide' | 'read_only' | 'editable';

export type ShareUrlGeneratedBaseParams = {
  share_id: string;
  object_type: ShareUrlGeneratedObjectType;
  metadata: boolean;
  custom_fields: ShareUrlGeneratedCustomFields;
  comments: ShareUrlGeneratedComments;
  version?: ShareUrlGeneratedVersion;
};

export type ShareUrlGeneratedBoardCollectionParams = ShareUrlGeneratedBaseParams & {
  object_type: 'board' | 'collection';
  hide_search_input: boolean;
  disable_view_settings: boolean;
  disable_expanding_nested: boolean;
};

export type UseTrackGeneratedShareUrlParams = ShareUrlGeneratedBaseParams | ShareUrlGeneratedBoardCollectionParams;

export const useTrackGeneratedShareUrl = () => {
  const { track } = useAnalyticsUtilities();

  const trackGeneratedShareUrl = useCallback(
    (params: UseTrackGeneratedShareUrlParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackGeneratedShareUrl };
};
